/**
 * Get Dynamic Backend URL
 * Automatically determines correct backend URL for any environment
 * Works with: local development, preview, production, forks
 */

// Debug mode - set to true to see backend URL logs
const DEBUG_MODE = false;

export const getBackendURL = () => {
  // Try environment variable first (set at build time)
  const envURL = process.env.REACT_APP_BACKEND_URL;
  if (envURL && envURL.startsWith('http')) {
    return envURL;
  }
  
  // Fallback: use current origin
  // In Emergent deployments, frontend and backend are on same domain
  // Routes are separated by /api prefix
  const currentOrigin = window.location.origin;
  if (DEBUG_MODE) {
    console.log('⚠️ REACT_APP_BACKEND_URL not set, using current origin:', currentOrigin);
  }
  return currentOrigin;
};

// Export as constant for direct use
export const BACKEND_URL = getBackendURL();

// Log for debugging (only once, only in debug mode)
if (DEBUG_MODE && !window.__BACKEND_URL_LOGGED) {
  console.log('🔗 Backend URL configured:', BACKEND_URL);
  window.__BACKEND_URL_LOGGED = true;
}
